import { wrapFetch } from '../libs/fetch';

type MemoResponse = {
  content: string;
};

export const fetchCompanyPersonMemo = async (personId: number) => {
  return await wrapFetch<MemoResponse>(`/api/v1/company_person_memos?person_id=${personId}`);
};

export const upsertCompanyPersonMemo = async (personId: number, content: string, csrfToken: string) => {
  return await wrapFetch<MemoResponse>('/api/v1/company_person_memos/upsert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ person_id: personId, content }),
    credentials: 'same-origin',
  });
};
